import React from 'react';
import PropTypes from 'prop-types';

import {Authorization} from '@appComponents/Authorization';
import ButtonAdd from '@appComponents/ButtonsCollection/ButtonAdd';
import {REPORT} from '@constants/resources';
import {SECURITY_PRIVILEGES_CREATE} from '@constants/variables';
import {convertSecondsToMinutesWithOneDecimal} from '@utils/helpers';

export function ReportButtons({eventId, buttonData = {}}) {
    const authorizationObject = {
        [REPORT]: SECURITY_PRIVILEGES_CREATE,
    };

    return (
        <Authorization authorization={authorizationObject}>
            {buttonData.showIncidentButton && (
                <ButtonAdd
                    label={'Report an incident'}
                    link={{
                        name: 'events.reportIncidents.add',
                        params: {
                            id: eventId,
                        },
                    }}
                />
            )}
            {buttonData.showNotStreamedButton && buttonData.hasUncoveredCombinations && (
                <ButtonAdd
                    label={'Report as not streamed'}
                    link={{
                        name: 'events.reportNotStreamed.add',
                        params: {
                            id: eventId,
                        },
                    }}
                />
            )}
            {buttonData.showWorkingButton && buttonData.hasUncoveredCombinations && (
                <ButtonAdd
                    label={'Report as working'}
                    link={{
                        name: 'events.reportWorking.add',
                        params: {
                            id: eventId,
                        },
                    }}
                />
            )}
            <ButtonAdd
                label={
                    null != buttonData?.duration
                        ? `Modify the duration of the event (${convertSecondsToMinutesWithOneDecimal(buttonData.duration)} min)`
                        : 'Set a duration for the event'
                }
                link={{
                    name: 'events.report.setEventDuration',
                    params: {
                        id: eventId,
                    },
                }}
            />
        </Authorization>
    );
}

ReportButtons.propTypes = {
    eventId: PropTypes.number.isRequired,
    buttonData: PropTypes.object,
};
